import React from 'react'

export const Check: React.FC = () => {
  return (
    <path d="M13.5938 2.625L5.375 10.8438L2.375 7.8125C2.21875 7.6875 1.96875 7.6875 1.84375 7.8125L0.9375 8.71875C0.8125 8.84375 0.8125 9.09375 0.9375 9.25L5.125 13.4062C5.28125 13.5625 5.5 13.5625 5.65625 13.4062L15.0312 4.03125C15.1562 3.90625 15.1562 3.65625 15.0312 3.5L14.125 2.625C14 2.46875 13.75 2.46875 13.5938 2.625Z" />
  )
}

export default Check
